<usb-base-item
  [item]="item"
  [styleSidebar]="styleSidebar"
  [currencyAgency]="currencyAgency"
  [currencies]="currencies"
  [clientsSettingAppBooking]="clientsSettingAppBooking"
>
  <!-- Insurance Details -->
  <div class="row pt-3">
    <!-- Left Column -->
    <div class="col-6">
      <!-- Adults -->
      <div class="d-flex align-items-center mb-4" style="gap: 2px;">
        <img width="20" height="20" src="../../../../../../assets/icons/itinerary/persona.svg"/>
        <span style="font-family: 'Rubik'; font-size: 13px; font-weight: 400; text-transform: none;">{{ item.adults }} {{ item.adults === 1 ? 'Adulto' : 'Adultos' }}</span>
      </div>

      <!-- Date -->
      <div class="d-flex flex-column mb-4">
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 400;
            line-height: 1.2;
            color: #3e3e3e;
            text-transform: none;
          "
        >
          Desde:
        </span>
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 500;
            line-height: 1.2;
            color: #000000;
            text-transform: none;
          "
        >
          {{ item.arrivalDate | date: "EEE. dd MMM yyyy" }}
        </span>
      </div>

      <div class="d-flex flex-column mb-4">
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 400;
            line-height: 1.2;
            color: #3e3e3e;
            text-transform: none;
          "
        >
          Origen:
        </span>
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 500;
            line-height: 1.2;
            color: #000000;
            text-transform: none;
          "
        >
          {{ item.form.begin }}
        </span>
      </div>
    </div>

    <div class="col-6">
      <!-- Childrens -->
      <div class="d-flex align-items-center mb-4" style="gap: 2px;">
        <img width="20" height="20" src="../../../../../../assets/icons/search-result/hotel/NIÑO.svg"/>
        <span style="font-family: 'Rubik'; font-size: 13px; font-weight: 400; text-transform: none;">{{ item.childrens }} {{ item.childrens === 1 ? 'Niño' : 'Niños' }}</span>
      </div>

      <!-- Time -->
      <div class="d-flex flex-column mb-4">
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 400;
            line-height: 1.2;
            color: #3e3e3e;
            text-transform: none;
          "
        >
          Hasta:
        </span>
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 500;
            line-height: 1.2;
            color: #000000;
            text-transform: none;
          "
        >
          {{ item.departureDate | date: "EEE. dd MMM yyyy" }}
        </span>
      </div>

      <div class="d-flex flex-column mb-4">
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 400;
            line-height: 1.2;
            color: #3e3e3e;
            text-transform: none;
          "
        >
          Destino:
        </span>
        <span
          style="
            font-family: 'Rubik';
            font-size: 13px;
            font-weight: 500;
            line-height: 1.2;
            color: #000000;
            text-transform: none;
          "
        >
          {{ item.form.destination }}
        </span>
      </div>
    </div>
  </div>


  <!-- Addons Included -->
  <div class="d-flex flex-column mb-3">
    <span
      style="
        font-size: 13px;
        font-weight: 500;
        font-family: 'Rubik';
        text-transform: none;
        line-height: 1.2;
      "
    >
      Adicionales
    </span>

    <ng-container *ngIf="!item.serviceExtra || item.serviceExtra.length === 0">
      <span
        style="
          font-size: 12px;
          font-weight: 400;
          font-family: 'Rubik';
          text-transform: none;
          line-height: 1.2;
        "
      >
        Sin adicionales
      </span>
    </ng-container>
    <ng-container *ngFor="let extra of item.serviceExtra">
      <div class="row">
        <div class="col-6">
          <div>
            <img class="mr-1" width="10" height="10" src="../../../../../../assets/img/app/little-icons/check.svg" />
            <span
              style="
                font-size: 12px;
                font-weight: 400;
                font-family: 'Rubik';
                text-transform: none;
                line-height: 1.2;
              "
            >
              {{ extra.name }}
            </span>
          </div>
        </div>

        <div class="col-6">
          <span
            style="
              font-size: 12px;
              font-weight: 400;
              font-family: 'Rubik';
              text-transform: none;
              line-height: 1.2;
            "
          >
            ARS {{ extra.price }}
          </span>
        </div>
      </div>
    </ng-container>
  </div>
</usb-base-item>
